import { getAmplitudeInstance } from '../amplitudeHelpers';

type logThreeDSecureActionRequiredParams = {
  checkout_session_id: string;
  payment_method?: string;
  product_id?: string;
  purchase_screen_type_plan?: string;
  purchase_type?: string;
  upsell_trigger?: string;
};

/**
 * Recurly returned a 3DS-required response for a purchase and the treatment-group client received a three_d_secure_action_token_id, so the 3DS flow is starting. Fires before the challenge UI is shown and does not imply an interactive challenge was displayed (3DS can be frictionless).
 * @param params - Attributes to log with the amplitude event
 * @param params.checkout_session_id - The client-generated checkout session id used to correlate the 3DS retry through to the final purchase outcome.
 * @param params.payment_method - The method of payment used for the purchase (e.g. credit_card, apple_pay, paypal).
 * @param params.product_id - The Recurly plan code / product id being purchased.
 * @param params.purchase_screen_type_plan - The plan shown on the purchasing screen (e.g. trial, non-trial, promo).
 * @param params.purchase_type - The purchase flow that triggered 3DS (e.g. initial_subscription, upgrade, gift).
 * @param params.upsell_trigger - The action that triggered the upsell to display.
 */
const logThreeDSecureActionRequired = (
  { checkout_session_id, payment_method, product_id, purchase_screen_type_plan, purchase_type, upsell_trigger }: logThreeDSecureActionRequiredParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    '3ds action required',
    {
      'checkout session id': checkout_session_id,
      'payment method': payment_method,
      'product id': product_id,
      'purchase screen type plan': purchase_screen_type_plan,
      'purchase type': purchase_type,
      'upsell trigger': upsell_trigger
    },
    callback
  );
};

export default logThreeDSecureActionRequired;
